import { default as Expenses } from "./Expenses";
import { default as OurWork } from "./OurWork";

export const ProgressBar = { OurWork, Expenses };
